import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
  	italics: 'Roboto-Italic.ttf',
  	bolditalics: 'Roboto-MediumItalic.ttf' 
	},
  Cour: {
    normal: 'CourierPrime-Regular.ttf',
    bold: 'CourierPrime-Bold.ttf',
    italics: 'CourierPrime-Italic.ttf',
    bolditalics: 'CourierPrime-BoldItalic.ttf'
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-arqueo',
  templateUrl: './arqueo.component.html',
  styleUrls: ['./arqueo.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class ArqueoComponent implements OnInit {
  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 3100;
  loading:boolean=false;
  mons:any=[];
  cajeros:any=[];
  cajerosUsr:any=[];
  item:any=[];
  tot: number = 0;
  totDocs: number = 0;
  totCaja:number = 0;
  diferencia:number = 0;
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];
  arqueo:number=0;

  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.fnGeneraPlantillaNueva();  
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
    this.dataService.getUsuarios('1_').subscribe(
                      rows => {   
                              this.cajeros = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCajerosCargados());
    this.dataService.getFormatoImp(3, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());
 
  }

  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnClickUsuario(idP){
    //console.log(idP);
    var auxIdP = [];
    this.cajerosUsr = [];
    for(var c = 0; c < this.cajeros.length; c++){
      if(this.cajeros[c].idPersona == idP){
        if(!this.cajeros[c].seleccionado)
          this.cajeros[c].seleccionado = true;
        else
          this.cajeros[c].seleccionado = false;
      }
      if(this.cajeros[c].seleccionado){
        auxIdP.push(this.cajeros[c].idUsuario);
        this.cajerosUsr.push(this.cajeros[c].idUsuario);
      }
    }
    var aux;
    aux = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial)
      aux = this.fechaEspecial;
    this.dataService.getArqueo(aux, "'" + auxIdP.join("','") + "'").subscribe(
                                rows => {   
                                        this.arqueo = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnArqueoCargado());
  }

  fnArqueoCargado(){
    //console.log("fnArqueoCargado");
    //console.log(this.arqueo);
    this.totCaja = this.arqueo;
    this.fnCalculaTotalEfectivo();
    this.fnCalculaDiferencia();
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("DD/MM/YYYY");
    //console.log(this.fechaEspecial);
  }

  fnCajerosCargados(){
    console.log(this.cajeros)
    for(var c = 0; c < this.cajeros.length; c++){
      this.cajeros[c].seleccionado = false;
    }
   }

  fnGeneraPlantillaNueva(){
     this.dataService.getMonedas().subscribe(
                      rows => {   
                              this.mons = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMonedasCargados());
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
    this.fnCalculaDiferencia();
  }
  
  fnMonedasCargados(){
    this.item = [];
    for(var m = 0; m < this.mons.length; m++){
      if(this.mons[m].act == 1){
        this.item.push({'id': this.mons[m].idMon,
                        'tipo': this.mons[m].tipo,
                        'nombre': this.mons[m].nombre,
                        'valor': this.mons[m].valor,
                        'qty': 0,
                        'subtot': 0
                      })
      }
    }
  }

  fnCalcula(item){
    var aux = <HTMLInputElement>document.getElementById("num_" + item.id);
    var sub = parseFloat(aux.value) * item.valor;
    item.qty = aux.value;
    item.subtot = sub;
    this.fnCalculaTotalEfectivo();
    this.fnCalculaDiferencia();
  }

  fnCalculaTotalEfectivo(){
    this.tot = 0;
    this.item.forEach(m => {
      this.tot += m.subtot;
    });
  }

  fnCalculaOtros(){
    var tot = 0;
    var aux = <HTMLInputElement>document.getElementById("monto_otro1");
    if(aux.value)
      tot = parseFloat(aux.value);
    aux = <HTMLInputElement>document.getElementById("monto_otro2");
    if(aux.value)
      tot += parseFloat(aux.value);
    aux = <HTMLInputElement>document.getElementById("monto_otro3");
      if(aux.value)
        tot += parseFloat(aux.value);
    aux = <HTMLInputElement>document.getElementById("monto_otro4");
      if(aux.value)
        tot += parseFloat(aux.value);
    aux = <HTMLInputElement>document.getElementById("monto_otro5");
      if(aux.value)
        tot += parseFloat(aux.value);
    this.totDocs = tot;
    this.fnCalculaDiferencia();
  }

  fnCalculaDiferencia(){
    setTimeout(() => {
      var txtCaja = <HTMLInputElement>document.getElementById("txtMonto");
      //console.log(txtCaja.value);
      var superTot = this.totDocs + this.tot;
      //console.log(superTot);
      this.diferencia = parseFloat(txtCaja.value) - superTot;
  
    }, 25);
  }

  fnImprimeReporte(idFormato){
    //console.log("Imprime Reporte");
    this.dataService.insLog(3,'IMPRIMIR', "ARQUEO",'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato, 0));              
  }

  fnElementosImpresionCargados(idFormato, ii){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    

    var data = [];
    data.push({"doc": "",
               "qty": "",
               "mon":"Monto de la Caja:",
               "imp":"$ " + this.dataService.fnFormatMoney(this.totCaja, 2)
              })
    data.push({"doc": "",
              "qty": "",
              "mon":"",
              "imp":""
             })              
    data.push({"doc": "",
               "qty": "#",
               "mon":"Denominación",
               "imp":"Importe"
              })
    for (var m = 0; m < this.item.length; m++){
      data.push({"doc": "",
                "qty": this.item[m].qty > 0 ? this.item[m].qty :  "-",
                "mon":this.item[m].tipo + " " + this.item[m].nombre,
                "imp": "$ " + this.dataService.fnFormatMoney( this.item[m].subtot, 2)
              })
    }
    //--> TOTAL EFECTIVO
    data.push({"doc": "",
              "qty": "",
              "mon": "TOTAL EFECTIVO",
              "imp": "$ " + this.dataService.fnFormatMoney(this.tot, 2)
        })
    //--> VACIO
    data.push({"doc": "",
              "qty": "",
              "mon": "",
              "imp": ""
        })
    //--> TITULOS DOCUMENTOS
    data.push({"doc": "Documentos",
              "qty": "",
              "mon": "",
              "imp": "Importe"
        })
    
    var totDoc = 0.0;
    var auxDoc = <HTMLInputElement>document.getElementById("monto_otro1");
    var auxMon = 0;
    try{
      auxMon = parseFloat(auxDoc.value);
    }
    catch{
      auxMon = null;
    }
    if(auxMon > 0){
      totDoc = auxMon;
      data.push({"doc": (<HTMLInputElement>document.getElementById("txt_otro1")).value,
                "qty": "",
                "mon": "",
                "imp": "$ " + this.dataService.fnFormatMoney( auxMon, 2)
              })
    }
    else{
      data.push({"doc": "",
                  "qty": "",
                  "mon": "",
                  "imp": ""
                })
    }
    auxDoc = <HTMLInputElement>document.getElementById("monto_otro2");
    auxMon = 0;
    try{
      auxMon = parseFloat(auxDoc.value);
    }
    catch{
      auxMon = null;
    }
    if(auxMon > 0){
      totDoc += auxMon;
      data.push({"doc": (<HTMLInputElement>document.getElementById("txt_otro2")).value,
                "qty": "",
                "mon": "",
                "imp": "$ " + this.dataService.fnFormatMoney( auxMon, 2)
              })
    }
    else{
      data.push({"doc": "",
                  "qty": "",
                  "mon": "",
                  "imp": ""
                })
    }
    auxDoc = <HTMLInputElement>document.getElementById("monto_otro3");
    auxMon = 0;
    try{
      auxMon = parseFloat(auxDoc.value);
    }
    catch{
      auxMon = null;
    }
    if(auxMon > 0){
      totDoc += auxMon;
      data.push({"doc": (<HTMLInputElement>document.getElementById("txt_otro3")).value,
                "qty": "",
                "mon": "",
                "imp": "$ " + this.dataService.fnFormatMoney( auxMon, 2)
              })
    }
    else{
      data.push({"doc": "",
                  "qty": "",
                  "mon": "",
                  "imp": ""
                })
    }
    auxDoc = <HTMLInputElement>document.getElementById("monto_otro4");
    auxMon = 0;
    try{
      auxMon = parseFloat(auxDoc.value);
    }
    catch{
      auxMon = null;
    }
    if(auxMon > 0){
      totDoc += auxMon;
      data.push({"doc": (<HTMLInputElement>document.getElementById("txt_otro4")).value,
                "qty": "",
                "mon": "",
                "imp": "$ " + this.dataService.fnFormatMoney( auxMon, 2)
              })
    }
    else{
      data.push({"doc": "",
                  "qty": "",
                  "mon": "",
                  "imp": ""
                })
    }    
    auxDoc = <HTMLInputElement>document.getElementById("monto_otro5");
    auxMon = 0;
    try{
      auxMon = parseFloat(auxDoc.value);
    }
    catch{
      auxMon = null;
    }
    if(auxMon > 0){
      totDoc += auxMon;
      data.push({"doc": (<HTMLInputElement>document.getElementById("txt_otro5")).value,
                "qty": "",
                "mon": "",
                "imp": "$ " + this.dataService.fnFormatMoney( auxMon, 2)
              })
    }
    else{
      data.push({"doc": "",
                  "qty": "",
                  "mon": "",
                  "imp": ""
                })
    }

    //if(totDoc > 0){
    //--> TOTAL DOCUMENTOS
      data.push({"doc": "",
                "qty": "",
                "mon": "TOTAL DOCUMENTOS",
                "imp": "$ " + this.dataService.fnFormatMoney(totDoc, 2)
          })
    //}
    //else{
      //console.log("POP!");
      //data.pop();
    //}
    //--> VACIO
    data.push({"doc": "",
              "qty": "",
              "mon": "",
              "imp": ""
        })
    //--> TOTAL CAJA
    data.push({"doc": "",
              "qty": "",
              "mon": "TOTAL EN CAJA",
              "imp": "$ " + this.dataService.fnFormatMoney(this.totCaja, 2)
        })
    //--> VACIO
    data.push({"doc": "",
              "qty": "",
              "mon": "",
              "imp": ""
        })
    //--> DIFERENCIA
    data.push({"doc": "",
              "qty": "",
              "mon": "DIFERENCIA",
              "imp": "$ " + this.dataService.fnFormatMoney(this.diferencia, 2)
        })


   // console.log(data);

    var auxColTit = ["Documento", "Qy", "Moneda","Importe"];
    var auxColId = ["doc","qty","mon", "imp"];
    var auxColumna=[];
    var strCol;
    var auxLen;
    var auxMonto;
    var auxNbsp;
    for(var c=0; c<auxColId.length; c++){
      strCol="";
      for(var r=0; r<data.length; r++){
        auxNbsp = "$";
        auxMonto = "";
        if(data[r][auxColId[c]]){
          if(c==0){
              auxLen = data[r][auxColId[c]];
          }
          else 
            auxLen = data[r][auxColId[c]];
        }
        else
          auxLen = "";
        if(c == 0 && auxLen.length > 72){
          strCol += auxLen.substr(0,72) + "ƒ" + auxLen.substr(72) + "ƒ";
          continue;
        }
        strCol += auxLen + "ƒ ƒ";   //--> Row vacío (prepara para Totales)
      }        
      /*
      if(c == 2)
        strCol += " " + "ƒ" + "   TOTAL EFECTIVO: "    //-->  Inserta un total multi columna 
      if(c == 1)
        strCol += " " + "ƒ" +this.tot    //-->  Inserta un total         
      if(c == 3){
        auxNbsp = "";
        for(var l = 11; l >=this.tot.toString().length; l--)
          auxNbsp += " ";
        //strCol += " " + "ƒ $" + auxNbsp + this.dataService.fnFormatMoney(this.totTotal, 2).slice(0, -3)    //-->  Inserta un total         
        //--> Versión Alineada a la derecha:
        strCol += " " + "ƒ $ " + this.dataService.fnFormatMoney(this.tot, 2) + "      \u00A0";   //-->  Inserta un total         
        }
      if(c != 4 && c != 5 && c != 6)
        strCol += " " + "ƒ";
      */
      auxColumna.push(strCol);
    }

    var arrSpecialStrings = [{
      'FECHAEMI': this.esFechaEspecial ? this.fechaEspecial : this.dataService.fnGetHoy(),
      'FILTRO1':  "",
      'DESTINATARIO': this.cajerosUsr.join(', '),
      'COLTIT': auxColTit,
      'COL': auxColumna
      //'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style:  this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    //image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    image: "logoBlack.png",
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: 'letter',
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(this.dd).print();
    pdfMake.createPdf(this.dd).open();
  }


}
